import { css } from '@emotion/react';
import { ai, jc, flex } from '~/modules/AppLayout/FlexGridCss';
import { fontWeight500, fontWeight600 } from '~/css/font';
import { createMobileCss2 } from '~/css/createMobileCss';
export const fubonHeaderCss = css `
  background-color: #f5f5f5;
`;
export const fubonTitleCss = css `
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  width: 264px;
  color: #020202;
  ${fontWeight600}
  font-size: 32px;
  margin: 0;
`;
export const fubonTimeAndActionSectionCss = css `
  ${flex.h.allCenter}
  width: 100%;
  margin: 16px 0;
`;
export const printerSectionCss = css `
  ${flex.h.allCenter}
  margin-left: auto;
`;
export const tradeLabelCss = (backgroundColor) => css `
  background: ${backgroundColor};
  color: #ffffff;
  border-radius: 8px;
  font-size: 18px;
  padding: 4px 12px;
  align-self: flex-start;
`;
//共用CSS
//客戶帳號資料--------------------------
export const accountBoxCss = css `
  ${flex.h.allCenter};
  width: 100%;
  font-size: 18px;
  ${fontWeight600}
`;
export const avatarCss = css `
  ${flex.h.allCenter};
  flex: 1;
`;
export const accountInfoCss = css `
  flex: 3;
  font-size: 18px;
`;
export const accountNameCss = css `
  ${flex.h.allCenter};
  justify-content: left;
  font-size: 18px;
`;
export const accountNumberCss = css `
  ${flex.h.allCenter};
  justify-content: left;
  font-size: 18px;
`;
export const headerItemKeyCss = css `
  font-size: 20px;
  ${fontWeight600}
`;
//帳戶收益分析------------------------------
//ReturnRate
export const rateboxCss = css `
  ${flex.h.crossCenter};
  width: 100%;
`;
export const rateKeyCss = css `
  ${flex.h.allCenter};
  width: 30%;
  font-size: 18px;
  ${fontWeight600}
`;
export const rateChartCss = css `
  ${flex.h.allCenter};
  width: 50%;
`;
export const rateValueCss = css `
  ${flex.h.allCenter};
  width: 20%;
  font-size: 18px;
  ${fontWeight600}
`;
//交易比重
//TradingProportion
//TradingFrequency
//PositionDuration
export const tradeKeyValueBoxCss = css `
  ${flex.v.allCenter};
  margin: auto 0;
`;
export const tradeItemCss = css `
  ${flex.h.crossCenter};
  ${jc.spaceBetween};
  width: 100%;
  padding: 0 16px;
`;
export const tradeKeyCss = css `
  font-size: 18px;
  ${fontWeight600};
  ${createMobileCss2(css `
    font-size: 16px;
  `)}
`;
export const tradeValueCss = css `
  text-align: right;
  font-size: 24px;
  ${fontWeight500};
  ${createMobileCss2(css `
    font-size: 20px;
  `)}
`;
//獲利、虧損三大排行CSS
//TopThreeProfitAndLoss
export const rankingSubtitleCss = (backgroundColor) => css `
  ${flex.h.allCenter};
  width: 100%;
  color: ${backgroundColor};
  font-size: 20px;
  ${fontWeight600};
  letter-spacing: 4px;
  text-align: center;
  padding-top: 30px;
`;
export const topThreeWrapperCss = css `
  ${flex.v.mainCenter};
  ${ai.stretch};
  flex: 1;
  width: 100%;
`;
export const topThreeBoxCss = css `
  flex: 1;
  background: #f5f5f5;
  padding: 16px 32px;
  border-radius: 8px;
  margin-top: 8px;
`;
export const topThreeSectionCss = css `
  ${flex.h.allCenter}
  text-align:center;
  margin: 8px 0;
  ${fontWeight600}
  & > * {
    flex: 1;
    font-size: 18px;
    text-align: left;
  }
  & > p:nth-of-type(2) {
    text-align: right;
  }
`;
export const rankingTitleCss = css `
  width: 30%;
`;
